module.exports = __webpack_public_path__ + "static/media/maersk-logo-grey.b8588bb7.png";